/* eslint-disable quotes */
/* eslint-disable object-curly-newline */
import {
  ARTICLE,
  IFRAME_ARTICLE,
  BUTTON_FOR_TASKBOT_HORIZONTAL,
  DIRECTLY_REDIRECTION,
  FEEDBACK,
  GENERAL_BTN,
  GENERAL_BTN_ITEM,
  GENERAL_BTN_MODAL_GUARANTEE,
  LIVE,
  MSG,
  OPTION,
  ORDER,
  QA_BUTTON,
  REDIRECTION,
  RR_REQUEST_INFO,
  tempCallback,
  TRANSACTION,
  IntentHotQuestion,
  NewHotQuestion,
  HotQuestionCategory,
  OrderCard,
  SPLater,
  Announcement,
  MySupportCase,
  OrderCardWithHQ,
  IMAGE,
  PODIMAGE,
  IntentSelector,
  OrdinatorySelector,
  OrderTipMsg,
  OrderSelectionFaq,
  OrderCardWithButton,
  CaseTrackerImprovement,
  FoodOrderCardWithButton,
  ChatUI_message,
  OrderSelector,
  TFE_OrderTipMsg,
  RRHotQuestions,
  OrderCardWithHQOrderDetail,
} from './mock_util';

export const mockTFE = {
  node_point_id: '',
  session_id: '773234947156296320',
  dialogue_id: '773235552738296448',
  dialogue_type: 'TASK',
  taskbot_id: '',
  taskbot_name: '',
  function: '',
  is_dialogue_end: false,
  replies: [
    {
      reply_type: 1003,
      message: {
        message_id: '776064147096455041',
        text_key: '',
        text_value: '',
        preview_message: 'Click for details',
        is_rich_text: false,
      },
      message_extra: {
        using_is_style: false,
        image_url: '',
        feedback_options: null,
        hot_questions: null,
        specific_hot_questions: null,
        hit_feedback: false,
        head_intents: null,
        next_head_intents: null,
        next_shortcut_intents: null,
        categories: null,
        cat_intent_list: null,
        order: null,
        list_display_option: null,
        list_items: null,
        support_case_display: null,
        grayscale_display_method: 0,
        has_announcement: false,
        thread_id: '776064021726585985',
        thread_node_id: '776064146708456576',
        is_bypass: false,
        task_flow_is_end: false,
        task_flow_text: null,
        task_flow_button_selector: null,
        task_flow_card: {
          task_bot_info: {
            bot_id: 16,
            case_id: '',
            task_bot_id: 'SOP7',
            flow_id: 'SOP7_F6',
            editor_node_id: 'SOP7_F6_Node37',
            node_id: 'SOP7_Node37.1',
            tf_node_id: 'SOP7_Node37',
            report_node_id: 'SOP7_F6_Node37.1',
            node_name: 'Custom Node',
            snapshot_id: 'SOP7_F6_1659518116',
          },
          is_bypass: false,
          is_end: false,
          has_more: false,
          is_select_other: false,
          card_type: 4,
          max_display: 3,
          status: [1, 2, 3, 4],
          default_status: 0,
          status_text: { '1': 'Pending', '2': 'Pending', '3': 'Completed', '4': 'Failed' },
          user_type: 0,
          select_content: 'select',
          select_other_content: 'select other',
          still_not_found_content: 'still not found',
          transaction_not_found_content: 'Still Don‘t See The Transaction Still Don‘t See The Transaction',
          check_here_content: 'check here',
          select_action: {
            current_task_bot_info: {
              bot_id: 16,
              case_id: '',
              task_bot_id: 'SOP7',
              flow_id: 'SOP7_F6',
              editor_node_id: 'SOP7_F6_Node37',
              node_id: 'SOP7_Node37.1',
              tf_node_id: 'SOP7_Node37',
              report_node_id: 'SOP7_F6_Node37.1',
              node_name: 'Custom Node',
              snapshot_id: 'SOP7_F6_1659518116',
            },
            bot_id: 16,
            flow_id: 'SOP7_F6',
            snapshot_id: 'SOP7_F6_1659518116',
            next_task_bot_id: '',
            next_node_id: 'SOP7_Node13',
            simulation_id: 0,
            params: { transaction_sn: { key: 'transaction_sn', data_type: 3, variate_type: 1, is_assigned: false }},
            is_bypass: false,
          },
          select_other_action: {
            current_task_bot_info: null,
            bot_id: 0,
            flow_id: '',
            snapshot_id: '',
            next_task_bot_id: '',
            next_node_id: '',
            simulation_id: 0,
            is_bypass: false,
            params: {
              page_num: {
                key: 'page_num',
                data_type: 1,
                is_assigned: false,
                variate_type: 0,
              },
              page_size: {
                key: 'page_size',
                data_type: 1,
                is_assigned: false,
                variate_type: 0,
              },
              status: {
                key: 'status',
                data_type: 1,
                is_assigned: false,
                variate_type: 0,
              },
            },
          },
          still_not_found_action: {
            current_task_bot_info: {
              bot_id: 16,
              case_id: '',
              task_bot_id: 'SOP7',
              flow_id: 'SOP7_F6',
              editor_node_id: 'SOP7_F6_Node37',
              node_id: 'SOP7_Node37.1',
              tf_node_id: 'SOP7_Node37',
              report_node_id: 'SOP7_F6_Node37.1',
              node_name: 'Custom Node',
              snapshot_id: 'SOP7_F6_1659518116',
            },
            bot_id: 16,
            flow_id: 'SOP7_F6',
            snapshot_id: 'SOP7_F6_1659518116',
            next_task_bot_id: '',
            next_node_id: 'SOP7_Node38',
            simulation_id: 0,
            is_bypass: false,
          },
          transaction_list: [
            {
              sn: 'UWSGR6BJGHLCZLWNEHUKZ2VUTUDG3',
              amount: 1471,
              bank_name: '',
              payment_channel_text: 'BCA OneKlik',
              create_time: '27 Jul 2022 17:53',
              status: 3,
            },
            {
              sn: 'UWS6N1LIJ4PNBMVXW1LJQIL61QX4A',
              amount: 10000,
              bank_name: '',
              payment_channel_text: 'BCA OneKlik',
              create_time: '27 Jul 2022 17:48',
              status: 3,
            },
            {
              sn: 'UWS5HYQD6SARKLFUFKUQFLKYZPHUE',
              amount: 2,
              bank_name: '',
              payment_channel_text: 'Debit Card',
              create_time: '27 Jul 2022 14:25',
              status: 3,
            },
            {
              sn: 'UWSFFPDCOLAIGGFW6J1MX4HHKETR3',
              amount: 2,
              bank_name: '',
              payment_channel_text: 'BRI Direct Debit',
              create_time: '27 Jul 2022 14:24',
              status: 6,
            },
            {
              sn: 'UWSZUDLYCFXPNFQDKUW6JML1MR1YM',
              amount: 10000,
              bank_name: '',
              payment_channel_text: 'BCA OneKlik',
              create_time: '26 Jul 2022 18:27',
              status: 3,
            },
            {
              sn: 'UWSEJRTCCI4MZIX4DZCZMB5BFYLEI',
              amount: 17968,
              bank_name: '',
              payment_channel_text: 'BCA OneKlik',
              create_time: '15 Jul 2022 16:17',
              status: 3,
            },
            {
              sn: 'UWSJMPWXTUKEEEJCXSRIPC6ZD2LN3',
              amount: 50000,
              bank_name: '',
              payment_channel_text: 'BCA OneKlik',
              create_time: '13 Jul 2022 17:42',
              status: 3,
            },
            {
              sn: 'UWSOZXMYICBCMR5KDL4LMMI5AHMHA',
              amount: 50000,
              bank_name: '',
              payment_channel_text: 'BCA OneKlik',
              create_time: '13 Jul 2022 17:41',
              status: 3,
            },
            {
              sn: 'UWSMKBB6S4OZSRL42QLHPPEWUAWPM',
              amount: 50000,
              bank_name: '',
              payment_channel_text: 'BCA OneKlik',
              create_time: '13 Jul 2022 17:40',
              status: 6,
            },
            {
              sn: 'UWSACEMBOSN4MEQUWRLBNAI4OXPGU',
              amount: 10000,
              bank_name: '',
              payment_channel_text: 'BCA OneKlik',
              create_time: '13 Jul 2022 14:36',
              status: 3,
            },
          ],
          food_delivery_list: [
            {
              delivery_id: 1,
              union_deliveries: [
                {
                  id: 1,
                  shop_name: 'testName',
                  delivery_status: 'Canceled',
                  create_time: 1667877417492,
                  receiver_name: 'testReceiverName',
                  delivery_location: 'testsLocation',
                },
              ],
            },
          ],
        },
        task_flow_related_intent: null,
        task_flow_popup: null,
        task_flow_option_selector: null,
        task_flow_article: null,
        task_flow_click_text_reply: null,
        task_flow_faq_list_reply: null,
        task_flow_image: null,
        label_clarification: null,
        simulator_mock: null,
        live_agent_auto_queue_info: null,
        live_agent_recommender_scenario: 0,
        live_agent_queue_info: null,
      },
    },
    {
      reply_type: 1003,
      message: {
        message_id: '770967117912972033',
        text_key: '',
        text_value: '',
        preview_message: 'Click for details',
        is_rich_text: false,
      },
      message_extra: {
        using_is_style: false,
        image_url: '',
        feedback_options: null,
        hot_questions: null,
        specific_hot_questions: null,
        hit_feedback: false,
        head_intents: null,
        next_head_intents: null,
        next_shortcut_intents: null,
        categories: null,
        cat_intent_list: null,
        order: null,
        list_display_option: null,
        list_items: null,
        support_case_display: null,
        grayscale_display_method: 0,
        has_announcement: false,
        thread_id: '770967085404610817',
        thread_node_id: '770967117524590848',
        is_bypass: false,
        task_flow_is_end: false,
        task_flow_text: null,
        task_flow_button_selector: null,
        task_flow_card: {
          task_bot_info: {
            bot_id: 8,
            case_id: '',
            task_bot_id: 'SOP8',
            flow_id: 'SOP8_F7',
            editor_node_id: 'SOP8_F7_Node11',
            node_id: 'SOP8_Node11.1',
            tf_node_id: 'SOP8_Node11',
            report_node_id: 'SOP8_F7_Node11.1',
            node_name: 'Custom Node',
            snapshot_id: 'SOP8_F7_1659002911',
          },
          is_bypass: false,
          is_end: false,
          has_more: true,
          is_select_other: false,
          card_type: 1,
          max_display: 3,
          status: [0, 1, 2, 4, 3, 5, 11],
          default_status: 0,
          status_text: {
            '0': 'All',
            '1': 'To Pay',
            '2': 'To Ship !!!',
            '3': 'To Receive',
            '4': 'Completed',
            '5': 'Cancelled',
            '6': 'Unpaid',
            '7': 'To Ship !!!',
            '8': 'Shipping',
            '9': 'Completed',
            '10': 'Cancellation',
            '11': 'Return Refund',
          },
          user_type: 0,
          select_content: '12',
          select_other_content: '31',
          still_not_found_content: '',
          transaction_not_found_content: '',
          check_here_content: '',
          select_action: {
            current_task_bot_info: {
              bot_id: 8,
              case_id: '',
              task_bot_id: 'SOP8',
              flow_id: 'SOP8_F7',
              editor_node_id: 'SOP8_F7_Node11',
              node_id: 'SOP8_Node11.1',
              tf_node_id: 'SOP8_Node11',
              report_node_id: 'SOP8_F7_Node11.1',
              node_name: 'Custom Node',
              snapshot_id: 'SOP8_F7_1659002911',
            },
            bot_id: 8,
            flow_id: 'SOP8_F7',
            snapshot_id: 'SOP8_F7_1659002911',
            next_task_bot_id: '',
            next_node_id: 'SOP8_Node12',
            simulation_id: 0,
            params: {
              order_id: { key: 'order_id', data_type: 1, variate_type: 1, is_assigned: false },
              return_id_interact: { key: 'return_id_interact', data_type: 1, variate_type: 1, is_assigned: false },
            },
            is_bypass: false,
          },
          select_other_action: {
            current_task_bot_info: {
              bot_id: 8,
              case_id: '',
              task_bot_id: 'SOP8',
              flow_id: 'SOP8_F7',
              editor_node_id: 'SOP8_F7_Node11',
              node_id: 'SOP8_Node11.1',
              tf_node_id: 'SOP8_Node11',
              report_node_id: 'SOP8_F7_Node11.1',
              node_name: 'Custom Node',
              snapshot_id: 'SOP8_F7_1659002911',
            },
            bot_id: 8,
            flow_id: 'SOP8_F7',
            snapshot_id: 'SOP8_F7_1659002911',
            next_task_bot_id: '',
            next_node_id: 'SOP8_Node11.2',
            simulation_id: 0,
            params: {
              page_num: { key: 'page_num', data_type: 1, variate_type: 0, is_assigned: false },
              page_size: { key: 'page_size', data_type: 1, variate_type: 0, is_assigned: false },
              status: { key: 'status', data_type: 1, variate_type: 0, is_assigned: false },
            },
            is_bypass: true,
          },
          still_not_found_action: {
            current_task_bot_info: null,
            bot_id: 0,
            flow_id: '',
            snapshot_id: '',
            next_task_bot_id: '',
            next_node_id: '',
            simulation_id: 0,
            is_bypass: false,
          },
          order_list: [
            {
              order_id: 104729048698329,
              order_sn: '220427N6YB0KES',
              return_id: 0,
              refund_id: 0,
              return_status: '',
              refund_amount: 0,
              shop_id: 601586935,
              checkout_id: 104729048632519,
              uri_key: 'order_detail_page',
              title: 'cg test product1',
              image: '89ab5de322d60c05b2db2c684c8fb261',
              price: 10,
              specification: '',
              button_type: 'btn_list',
              button_id: 'btn_0',
              tracing_number: '',
              delivered_by: '',
              order_list_type: 0,
              total_price: 14,
              shop_name: '',
              shop_image: null,
              item_count: 1,
              order_image: null,
              user_id: 0,
              items: [
                {
                  amount: 1,
                  order_price: 10,
                  title: 'cg test product1',
                  image: ['89ab5de322d60c05b2db2c684c8fb261'],
                  specification: '',
                },
              ],
              currency: 'SGD',
              buyer_pay_amount: 1400000,
              seller_estimated_escrow: 0,
              default_price: 1400000,
              price_before_discount: 0,
              has_request_refund: false,
              create_time: 1651029844,
              list_type: 4,
              order_status: 5,
            },
            {
              order_id: 104728784667892,
              order_sn: '220427N6QF717M',
              return_id: 0,
              refund_id: 0,
              return_status: '',
              refund_amount: 0,
              shop_id: 601586935,
              checkout_id: 104728784672470,
              uri_key: 'order_detail_page',
              title: 'cg test product1',
              image: '89ab5de322d60c05b2db2c684c8fb261',
              price: 10,
              specification: '',
              button_type: 'btn_list',
              button_id: 'btn_0',
              tracing_number: '',
              delivered_by: '',
              order_list_type: 0,
              total_price: 14,
              shop_name: '',
              shop_image: null,
              item_count: 1,
              order_image: null,
              user_id: 0,
              items: [
                {
                  amount: 1,
                  order_price: 10,
                  title: 'cg test product1',
                  image: ['89ab5de322d60c05b2db2c684c8fb261'],
                  specification: '',
                },
              ],
              currency: 'SGD',
              buyer_pay_amount: 1400000,
              seller_estimated_escrow: 1383000,
              default_price: 1400000,
              price_before_discount: 1400000,
              has_request_refund: false,
              create_time: 1651029580,
              list_type: 7,
              order_status: 2,
            },
            {
              order_id: 104728578629407,
              order_sn: '220427N6HAQ7RY',
              return_id: 0,
              refund_id: 0,
              return_status: '',
              refund_amount: 0,
              shop_id: 601586935,
              checkout_id: 104728578674565,
              uri_key: 'order_detail_page',
              title: 'cg test product1',
              image: '89ab5de322d60c05b2db2c684c8fb261',
              price: 10,
              specification: '',
              button_type: 'btn_list',
              button_id: 'btn_0',
              tracing_number: '',
              delivered_by: '',
              order_list_type: 0,
              total_price: 14,
              shop_name: '',
              shop_image: null,
              item_count: 1,
              order_image: null,
              user_id: 0,
              items: [
                {
                  amount: 1,
                  order_price: 10,
                  title: 'cg test product1',
                  image: ['89ab5de322d60c05b2db2c684c8fb261'],
                  specification: '',
                },
              ],
              currency: 'SGD',
              buyer_pay_amount: 1400000,
              seller_estimated_escrow: 1383000,
              default_price: 1400000,
              price_before_discount: 1400000,
              has_request_refund: false,
              create_time: 1651029378,
              list_type: 7,
              order_status: 2,
            },
          ],
        },
        task_flow_related_intent: null,
        task_flow_popup: null,
        task_flow_option_selector: null,
        task_flow_article: null,
        task_flow_click_text_reply: null,
        task_flow_faq_list_reply: null,
        task_flow_image: null,
        label_clarification: null,
        simulator_mock: null,
        live_agent_auto_queue_info: null,
        live_agent_recommender_scenario: 0,
        live_agent_queue_info: null,
      },
    },
    {
      reply_type: 1004,
      message: {
        message_id: '4',
      },
      message_extra: {
        task_flow_related_intent: {
          task_bot_info: {
            bot_id: 8,
            case_id: '',
            task_bot_id: 'SOP8',
            flow_id: 'SOP8_F11',
            editor_node_id: 'SOP8_F11_Node13',
            node_id: 'SOP8_Node13',
            tf_node_id: 'SOP8_Node13',
            report_node_id: 'SOP8_F11_Node13',
            node_name: 'Custom Node',
            snapshot_id: 'SOP8_F11_1659593787',
          },
          content: 'You may want to ask: ',
          intents: [
            {
              intent_id: 123,
              intent_name: 'When will I receive my item?',
            },
            {
              intent_id: 234,
              intent_name: 'How do I verify/change my phone number?',
            },
            {
              intent_id: 345,
              intent_name: 'Why cant I use my phone number to sign up?',
            },
          ],
        },
      },
    },
    {
      reply_type: 1005,
      message: {
        message_id: '773259009927530368',
        text_key: '',
        text_value: '',
        preview_message: 'Click for details',
        is_rich_text: false,
      },
      message_extra: {
        using_is_style: false,
        image_url: '',
        feedback_options: null,
        hot_questions: null,
        specific_hot_questions: null,
        hit_feedback: false,
        head_intents: null,
        next_head_intents: null,
        next_shortcut_intents: null,
        categories: null,
        cat_intent_list: null,
        order: null,
        list_display_option: null,
        list_items: null,
        support_case_display: null,
        grayscale_display_method: 0,
        has_announcement: false,
        thread_id: '773258992302220289',
        thread_node_id: '773259009473700864',
        is_bypass: false,
        task_flow_is_end: false,
        task_flow_text: null,
        task_flow_button_selector: null,
        task_flow_card: null,
        task_flow_related_intent: null,
        task_flow_popup: {
          task_bot_info: {
            bot_id: 1,
            case_id: '',
            task_bot_id: 'SOP151',
            flow_id: 'SOP151_F12',
            editor_node_id: 'SOP151_F12_Node20',
            node_id: 'SOP151_Node20',
            tf_node_id: 'SOP151_Node20',
            report_node_id: 'SOP151_F12_Node20',
            node_name: 'Custom Node',
            snapshot_id: 'SOP151_F12_1659596645',
          },
          is_bypass: false,
          is_end: false,
          title: 'abababa',
          content: '<p>abababa</p>',
          left_button: {
            button_id: 'btn_16',
            button_text: 'A',
            action: {
              action_type: 2,
              is_bypass: false,
              task_bot_action: {
                current_task_bot_info: {
                  bot_id: 1,
                  case_id: '',
                  task_bot_id: 'SOP151',
                  flow_id: 'SOP151_F12',
                  editor_node_id: 'SOP151_F12_Node20',
                  node_id: 'SOP151_Node20',
                  tf_node_id: 'SOP151_Node20',
                  report_node_id: 'SOP151_F12_Node20',
                  node_name: 'Custom Node',
                  snapshot_id: 'SOP151_F12_1659596645',
                },
                bot_id: 1,
                flow_id: 'SOP151_F12',
                snapshot_id: 'SOP151_F12_1659596645',
                next_task_bot_id: '',
                next_node_id: 'SOP151_Node21',
                simulation_id: 0,
                params: {
                  user_type: { key: 'user_type', data_type: 1, variate_type: 1, int_val: 1, is_assigned: true },
                },
                is_bypass: false,
              },
            },
          },
          right_button: {
            button_id: 'btn_17',
            button_text: 'B',
            action: {
              action_type: 2,
              is_bypass: false,
              task_bot_action: {
                current_task_bot_info: {
                  bot_id: 1,
                  case_id: '',
                  task_bot_id: 'SOP151',
                  flow_id: 'SOP151_F12',
                  editor_node_id: 'SOP151_F12_Node20',
                  node_id: 'SOP151_Node20',
                  tf_node_id: 'SOP151_Node20',
                  report_node_id: 'SOP151_F12_Node20',
                  node_name: 'Custom Node',
                  snapshot_id: 'SOP151_F12_1659596645',
                },
                bot_id: 1,
                flow_id: 'SOP151_F12',
                snapshot_id: 'SOP151_F12_1659596645',
                next_task_bot_id: '',
                next_node_id: 'SOP151_Node21',
                simulation_id: 0,
                params: {
                  user_type: { key: 'user_type', data_type: 1, variate_type: 1, int_val: 2, is_assigned: true },
                },
                is_bypass: false,
              },
            },
          },
        },
        task_flow_option_selector: null,
        task_flow_article: null,
        task_flow_click_text_reply: null,
        task_flow_faq_list_reply: null,
        task_flow_image: null,
        label_clarification: null,
        simulator_mock: null,
        live_agent_auto_queue_info: null,
        live_agent_recommender_scenario: 0,
        live_agent_queue_info: null,
      },
    },
    {
      reply_type: 1002,
      message: {
        message_id: '773235578624246656',
        text_key: '',
        text_value: '',
        preview_message: 'Click for details',
        is_rich_text: false,
      },
      message_extra: {
        using_is_style: false,
        image_url: '',
        feedback_options: null,
        hot_questions: null,
        specific_hot_questions: null,
        hit_feedback: false,
        head_intents: null,
        next_head_intents: null,
        next_shortcut_intents: null,
        categories: null,
        cat_intent_list: null,
        order: null,
        list_display_option: null,
        list_items: null,
        support_case_display: null,
        grayscale_display_method: 0,
        has_announcement: false,
        thread_id: '773235554281800321',
        thread_node_id: '773235578231276160',
        is_bypass: false,
        task_flow_is_end: false,
        task_flow_text: null,
        task_flow_button_selector: {
          task_bot_info: {
            bot_id: 8,
            case_id: '',
            task_bot_id: 'SOP8',
            flow_id: 'SOP8_F11',
            editor_node_id: 'SOP8_F11_Node13',
            node_id: 'SOP8_Node13',
            tf_node_id: 'SOP8_Node13',
            report_node_id: 'SOP8_F11_Node13',
            node_name: 'Custom Node',
            snapshot_id: 'SOP8_F11_1659593787',
          },
          is_bypass: false,
          is_end: false,
          style: 1,
          content: 'who are you?',
          buttons: [
            {
              button_id: 'btn_01',
              button_text: 'A',
              action: {
                action_type: 2,
                is_bypass: false,
                task_bot_action: {
                  current_task_bot_info: {
                    bot_id: 8,
                    case_id: '',
                    task_bot_id: 'SOP8',
                    flow_id: 'SOP8_F11',
                    editor_node_id: 'SOP8_F11_Node13',
                    node_id: 'SOP8_Node13',
                    tf_node_id: 'SOP8_Node13',
                    report_node_id: 'SOP8_F11_Node13',
                    node_name: 'Custom Node',
                    snapshot_id: 'SOP8_F11_1659593787',
                  },
                  bot_id: 8,
                  flow_id: 'SOP8_F11',
                  snapshot_id: 'SOP8_F11_1659593787',
                  next_task_bot_id: '',
                  next_node_id: 'SOP8_Node14',
                  simulation_id: 0,
                  params: {
                    user_type: { key: 'user_type', data_type: 1, variate_type: 1, int_val: 1, is_assigned: true },
                  },
                  is_bypass: false,
                },
              },
            },
            {
              button_id: 'btn_02',
              button_text: 'B',
              action: {
                action_type: 2,
                is_bypass: false,
                task_bot_action: {
                  current_task_bot_info: {
                    bot_id: 8,
                    case_id: '',
                    task_bot_id: 'SOP8',
                    flow_id: 'SOP8_F11',
                    editor_node_id: 'SOP8_F11_Node13',
                    node_id: 'SOP8_Node13',
                    tf_node_id: 'SOP8_Node13',
                    report_node_id: 'SOP8_F11_Node13',
                    node_name: 'Custom Node',
                    snapshot_id: 'SOP8_F11_1659593787',
                  },
                  bot_id: 8,
                  flow_id: 'SOP8_F11',
                  snapshot_id: 'SOP8_F11_1659593787',
                  next_task_bot_id: '',
                  next_node_id: 'SOP8_Node14',
                  simulation_id: 0,
                  params: {
                    user_type: { key: 'user_type', data_type: 1, variate_type: 1, int_val: 2, is_assigned: true },
                  },
                  is_bypass: false,
                },
              },
            },
          ],
        },
        task_flow_card: null,
        task_flow_related_intent: null,
        task_flow_popup: null,
        task_flow_option_selector: null,
        task_flow_article: null,
        task_flow_click_text_reply: null,
        task_flow_faq_list_reply: null,
        task_flow_image: null,
        label_clarification: null,
        simulator_mock: null,
        live_agent_auto_queue_info: null,
        live_agent_recommender_scenario: 0,
        live_agent_queue_info: null,
      },
    },
    {
      reply_type: 1014,
      message: {
        message_id: '5',
      },
      message_extra: {
        task_flow_food_buyer_order_detail: {
          task_bot_info: {
            bot_id: 8,
            case_id: '',
            task_bot_id: 'SOP8',
            flow_id: 'SOP8_F11',
            editor_node_id: 'SOP8_F11_Node13',
            node_id: 'SOP8_Node13',
            tf_node_id: 'SOP8_Node13',
            report_node_id: 'SOP8_F11_Node13',
            node_name: 'Custom Node',
            snapshot_id: 'SOP8_F11_1659593787',
          },
          order_brief: {
            id: 111,
            user_id: 1000,
            currency: '$',
            place_time: 1669540803000,
            store_id: 999,
            store_name: 'store name',
            store_logo: 'sss',
            total_amount: 100,
            payment_method: 1,
            order_status: 1,
          },
        },
      },
    },
    {
      reply_type: 1015,
      message: {
        message_id: '6',
      },
      message_extra: {
        task_flow_food_buyer_order_card_selector: {
          task_bot_info: {
            bot_id: 8,
            case_id: '',
            task_bot_id: 'SOP8',
            flow_id: 'SOP8_F11',
            editor_node_id: 'SOP8_F11_Node13',
            node_id: 'SOP8_Node13',
            tf_node_id: 'SOP8_Node13',
            report_node_id: 'SOP8_F11_Node13',
            node_name: 'Custom Node',
            snapshot_id: 'SOP8_F11_1659593787',
          },
          title: 'Do you want to ask about this question?',
          buttons: [
            {
              button_id: 'btn_01',
              button_text: 'A',
              action: {
                action_type: 2,
                is_bypass: false,
                task_bot_action: {
                  current_task_bot_info: {
                    bot_id: 8,
                    case_id: '',
                    task_bot_id: 'SOP8',
                    flow_id: 'SOP8_F11',
                    editor_node_id: 'SOP8_F11_Node13',
                    node_id: 'SOP8_Node13',
                    tf_node_id: 'SOP8_Node13',
                    report_node_id: 'SOP8_F11_Node13',
                    node_name: 'Custom Node',
                    snapshot_id: 'SOP8_F11_1659593787',
                  },
                  bot_id: 8,
                  flow_id: 'SOP8_F11',
                  snapshot_id: 'SOP8_F11_1659593787',
                  next_task_bot_id: '',
                  next_node_id: 'SOP8_Node14',
                  simulation_id: 0,
                  params: {
                    food_buyer_order_id: { key: 'food_buyer_order_id', data_type: 1, variate_type: 1, int_val: 1, is_assigned: true },
                  },
                  is_bypass: false,
                },
              },
            },
            {
              button_id: 'btn_02',
              button_text: 'B',
              action: {
                action_type: 10,
                is_bypass: false,
                task_bot_action: {
                  current_task_bot_info: {
                    bot_id: 8,
                    case_id: '',
                    task_bot_id: 'SOP8',
                    flow_id: 'SOP8_F11',
                    editor_node_id: 'SOP8_F11_Node13',
                    node_id: 'SOP8_Node13',
                    tf_node_id: 'SOP8_Node13',
                    report_node_id: 'SOP8_F11_Node13',
                    node_name: 'Custom Node',
                    snapshot_id: 'SOP8_F11_1659593787',
                  },
                  bot_id: 8,
                  flow_id: 'SOP8_F11',
                  snapshot_id: 'SOP8_F11_1659593787',
                  next_task_bot_id: '',
                  next_node_id: 'SOP8_Node14',
                  simulation_id: 0,
                  params: {
                    food_buyer_order_id: { key: 'food_buyer_order_id', data_type: 1, variate_type: 1, int_val: 2, is_assigned: false },
                  },
                  is_bypass: false,
                },
              },
            },
          ],
        },
      },
    }
  ],
};

export const mockAll = {
  session_id: '317375662447691264',
  dialogue_id: '317375682387412480',
  dialogue_type: 'TASK',
  taskbot_id: 'SOP_1',
  taskbot_name: 'Order',
  is_dialogue_end: false,
  replies: [
    // {
    //   reply_type: 15,
    //   message: {
    //     message_id: '520405443978199169',
    //     text_key: '',
    //     text_value: '',
    //   },
    //   message_extra: {
    //     buttons_for_general: [
    //       {
    //         button_type: 'btn_live',
    //         node_id: '',
    //         text_key: 'sop_2_node_0_2_1_btn_1',
    //         text_value: "Still don't see the Withdrawal",
    //         url: '',
    //         uri_key: '',
    //         queue_name: 'ID Chat-Buyer-ShopeePay',
    //         uri_extra: null,
    //         extra_param: null,
    //         article_number: '',
    //         should_disappear: false,
    //         order_extra: null,
    //         style: 0,
    //         callback: null,
    //         btn_modal_callback: null,
    //         button_id: 'btn_0',
    //         is_seller: false,
    //       },
    //       {
    //         button_type: 'btn_live',
    //         node_id: '',
    //         text_key: 'sop_2_node_0_2_1_1_btn_6',
    //         text_value: 'Check here',
    //         url: '',
    //         uri_key: '',
    //         queue_name: 'ID Chat-Buyer-ShopeePay',
    //         uri_extra: null,
    //         extra_param: 'Still do not see the transaction?',
    //         article_number: '',
    //         should_disappear: false,
    //         order_extra: null,
    //         style: 0,
    //         callback: null,
    //         btn_modal_callback: null,
    //         button_id: 'btn_1',
    //         is_seller: false,
    //       },
    //     ],
    //     feedback_options: null,
    //     transactions: {
    //       node_id: 'SOP_2_NODE_0_3_1_1',
    //       type: 2,
    //       has_more: true,
    //       more_button_type: 'btn_more',
    //       more_button_id: 'btn_1',
    //       list: [
    //         {
    //           sn: 'BIBILAILAI123456',
    //           amount: 1.23456,
    //           bank_name: 'bank_name_1',
    //           payment_channel_text: 'payment_channel_1',
    //           create_time: '20-08-2021 17:09',
    //           button_type: 'btn_list',
    //           button_id: 'btn_0',
    //           status: 1,
    //         },
    //         {
    //           sn: 'lalalalalala1',
    //           amount: 6.54321,
    //           bank_name: 'bank_name_2',
    //           payment_channel_text: 'payment_channel_2',
    //           create_time: '20-08-2021 17:09',
    //           button_type: 'btn_list',
    //           button_id: 'btn_0',
    //           status: 1,
    //         },
    //         {
    //           sn: 'BIBILAILAI123456',
    //           amount: 1.23456,
    //           bank_name: 'bank_name_1',
    //           payment_channel_text: 'payment_channel_1',
    //           create_time: '20-08-2021 17:09',
    //           button_type: 'btn_list',
    //           button_id: 'btn_0',
    //           status: 1,
    //         },
    //       ],
    //     },
    //     hot_questions: null,
    //     specific_hot_questions: null,
    //     hit_feedback: false,
    //     head_intents: null,
    //     next_head_intents: null,
    //     categories: null,
    //     cat_intent_list: null,
    //     order: null,
    //     list_display_option: null,
    //     list_items: null,
    //     support_case_display: null,
    //   },
    // },
    // {
    //   reply_type: 15,
    //   message: {
    //     message_id: '520283564156125313',
    //     text_key: '',
    //     text_value: '',
    //   },
    //   message_extra: {
    //     buttons_for_general: [
    //       {
    //         button_type: 'btn_taskbot',
    //         node_id: 'SOP_2_NODE_D20',
    //         text_key: 'sop_2_node_0_2_1_1_btn_5',
    //         text_value: "Still don't see the Topup?",
    //         url: '',
    //         uri_key: '',
    //         queue_name: '',
    //         uri_extra: null,
    //         extra_param: null,
    //         article_number: '',
    //         should_disappear: false,
    //         order_extra: null,
    //         style: 0,
    //         callback: null,
    //         btn_modal_callback: null,
    //         button_id: 'btn_0',
    //         is_seller: false,
    //       },
    //       {
    //         button_type: 'btn_taskbot',
    //         node_id: 'SOP_2_NODE_D20',
    //         text_key: 'sop_2_node_0_2_1_1_btn_6',
    //         text_value: 'Check here',
    //         url: '',
    //         uri_key: '',
    //         queue_name: '',
    //         uri_extra: null,
    //         extra_param: 'Still do not see the transaction?',
    //         article_number: '',
    //         should_disappear: false,
    //         order_extra: null,
    //         style: 0,
    //         callback: null,
    //         btn_modal_callback: null,
    //         button_id: 'btn_0',
    //         is_seller: false,
    //       },
    //     ],
    //     feedback_options: null,
    //     transactions: {
    //       node_id: 'SOP_2_NODE_0_2_1_1',
    //       type: 1,
    //       has_more: true,
    //       more_button_type: 'btn_more',
    //       more_button_id: 'btn_1',
    //       list: [
    //         {
    //           sn: 'BIBILAILAI123456',
    //           amount: 1.23456,
    //           bank_name: 'bank_name_1',
    //           payment_channel_text: 'payment_channel_1',
    //           create_time: '20-08-2021 13:07',
    //           button_type: 'btn_list',
    //           button_id: 'btn_0',
    //           status: 1,
    //         },
    //         {
    //           sn: 'lalalalalala1',
    //           amount: 6.54321,
    //           bank_name: 'bank_name_2',
    //           payment_channel_text: 'payment_channel_2',
    //           create_time: '20-08-2021 13:07',
    //           button_type: 'btn_list',
    //           button_id: 'btn_0',
    //           status: 3,
    //         },
    //         {
    //           sn: 'BIBILAILAI123456',
    //           amount: 1.23456,
    //           bank_name: 'bank_name_1',
    //           payment_channel_text: 'payment_channel_1',
    //           create_time: '20-08-2021 13:07',
    //           button_type: 'btn_list',
    //           button_id: 'btn_0',
    //           status: 4,
    //         },
    //       ],
    //     },
    //     hot_questions: null,
    //     specific_hot_questions: null,
    //     hit_feedback: false,
    //     head_intents: null,
    //     next_head_intents: null,
    //     categories: null,
    //     cat_intent_list: null,
    //     order: null,
    //     list_display_option: null,
    //     list_items: null,
    //     support_case_display: null,
    //   },
    // },
    // {
    //   reply_type: 15,
    //   message: {
    //     message_id: '520275342229766273',
    //     text_key: '',
    //     text_value: '',
    //   },
    //   message_extra: {
    //     buttons_for_general: [
    //       {
    //         button_type: 'btn_taskbot',
    //         node_id: 'SOP_2_NODE_D20',
    //         text_key: 'sop_2_node_0_2_1_1_btn_5',
    //         text_value: '',
    //         url: '',
    //         uri_key: '',
    //         queue_name: '',
    //         uri_extra: null,
    //         extra_param: null,
    //         article_number: '',
    //         should_disappear: false,
    //         order_extra: null,
    //         style: 0,
    //         callback: null,
    //         btn_modal_callback: null,
    //         button_id: 'btn_0',
    //         is_seller: false,
    //       },
    //       {
    //         button_type: 'btn_taskbot',
    //         node_id: 'SOP_2_NODE_D20',
    //         text_key: 'sop_2_node_0_2_1_1_btn_6',
    //         text_value: 'Check here',
    //         url: '',
    //         uri_key: '',
    //         queue_name: '',
    //         uri_extra: null,
    //         extra_param: 'Still do not see the transaction?',
    //         article_number: '',
    //         should_disappear: false,
    //         order_extra: null,
    //         style: 0,
    //         callback: null,
    //         btn_modal_callback: null,
    //         button_id: 'btn_0',
    //         is_seller: false,
    //       },
    //     ],
    //     feedback_options: null,
    //     transactions: {
    //       node_id: 'SOP_2_NODE_0_2_1_1',
    //       type: 1,
    //       has_more: false,
    //       more_button_type: 'btn_live',
    //       more_button_id: 'btn_3',
    //       list: [
    //         {
    //           sn: 'BIBILAILAI123456',
    //           amount: 1.23456,
    //           bank_name: 'bank_name_1',
    //           payment_channel_text: 'payment_channel_1',
    //           create_time: '20-08-2021 12:51',
    //           button_type: 'btn_list',
    //           button_id: 'btn_0',
    //           status: 1,
    //         },
    //         {
    //           sn: 'lalalalalala1',
    //           amount: 6.54321,
    //           bank_name: 'bank_name_2',
    //           payment_channel_text: 'payment_channel_2',
    //           create_time: '20-08-2021 12:51',
    //           button_type: 'btn_list',
    //           button_id: 'btn_0',
    //           status: 1,
    //         },
    //       ],
    //       "is_bypass": true,
    //     },
    //     "still_not_found_action": {
    //       "current_task_bot_info": null,
    //       "bot_id": 0,
    //       "flow_id": "",
    //       "snapshot_id": "",
    //       "next_task_bot_id": "",
    //       "next_node_id": "",
    //       "simulation_id": 0,
    //       "is_bypass": false,
    //     },
    //     "order_list": [{
    //       "order_id": 104729048698329,
    //       "order_sn": "220427N6YB0KES",
    //       "return_id": 0,
    //       "refund_id": 0,
    //       "return_status": "",
    //       "refund_amount": 0,
    //       "shop_id": 601586935,
    //       "checkout_id": 104729048632519,
    //       "uri_key": "order_detail_page",
    //       "title": "cg test product1",
    //       "image": "89ab5de322d60c05b2db2c684c8fb261",
    //       "price": 10,
    //       "specification": "",
    //       "button_type": "btn_list",
    //       "button_id": "btn_0",
    //       "tracing_number": "",
    //       "delivered_by": "",
    //       "order_list_type": 0,
    //       "total_price": 15,
    //       "shop_name": "",
    //       "shop_image": null,
    //       "item_count": 2,
    //       "order_image": null,
    //       "user_id": 0,
    //       "items": [{
    //         "amount": 1,
    //         "order_price": 10,
    //         "title": "cg test product1",
    //         "image": ["89ab5de322d60c05b2db2c684c8fb261"],
    //         "specification": "",
    //       }],
    //       "currency": "SGD",
    //       "buyer_pay_amount": 1400000,
    //       "seller_estimated_escrow": 0,
    //       "default_price": 1400000,
    //       "price_before_discount": 0,
    //       "has_request_refund": false,
    //       "create_time": 1651029844,
    //       "list_type": 4,
    //       "order_status": 5,
    //     }, {
    //       "order_id": 104728784667892,
    //       "order_sn": "220427N6QF717M",
    //       "return_id": 0,
    //       "refund_id": 0,
    //       "return_status": "",
    //       "refund_amount": 0,
    //       "shop_id": 601586935,
    //       "checkout_id": 104728784672470,
    //       "uri_key": "order_detail_page",
    //       "title": "cg test product1",
    //       "image": "89ab5de322d60c05b2db2c684c8fb261",
    //       "price": 10,
    //       "specification": "",
    //       "button_type": "btn_list",
    //       "button_id": "btn_0",
    //       "tracing_number": "",
    //       "delivered_by": "",
    //       "order_list_type": 0,
    //       "total_price": 14,
    //       "shop_name": "",
    //       "shop_image": null,
    //       "item_count": 1,
    //       "order_image": null,
    //       "user_id": 0,
    //       "items": [{
    //         "amount": 1,
    //         "order_price": 10,
    //         "title": "cg test product1",
    //         "image": ["89ab5de322d60c05b2db2c684c8fb261"],
    //         "specification": "",
    //       }],
    //       "currency": "SGD",
    //       "buyer_pay_amount": 1400000,
    //       "seller_estimated_escrow": 1383000,
    //       "default_price": 1400000,
    //       "price_before_discount": 1400000,
    //       "has_request_refund": false,
    //       "create_time": 1651029580,
    //       "list_type": 7,
    //       "order_status": 2,
    //     }, {
    //       "order_id": 104728578629407,
    //       "order_sn": "220427N6HAQ7RY",
    //       "return_id": 0,
    //       "refund_id": 0,
    //       "return_status": "",
    //       "refund_amount": 0,
    //       "shop_id": 601586935,
    //       "checkout_id": 104728578674565,
    //       "uri_key": "order_detail_page",
    //       "title": "cg test product1",
    //       "image": "89ab5de322d60c05b2db2c684c8fb261",
    //       "price": 10,
    //       "specification": "",
    //       "button_type": "btn_list",
    //       "button_id": "btn_0",
    //       "tracing_number": "",
    //       "delivered_by": "",
    //       "order_list_type": 0,
    //       "total_price": 14,
    //       "shop_name": "",
    //       "shop_image": null,
    //       "item_count": 3,
    //       "order_image": null,
    //       "user_id": 0,
    //       "items": [{
    //         "amount": 1,
    //         "order_price": 10,
    //         "title": "cg test product1",
    //         "image": ["89ab5de322d60c05b2db2c684c8fb261"],
    //         "specification": "",
    //       }],
    //       "currency": "SGD",
    //       "buyer_pay_amount": 1400000,
    //       "seller_estimated_escrow": 1383000,
    //       "default_price": 1400000,
    //       "price_before_discount": 1400000,
    //       "has_request_refund": false,
    //       "create_time": 1651029378,
    //       "list_type": 7,
    //       "order_status": 2,
    //     }],
    //   },
    //   hot_questions: null,
    //   specific_hot_questions: null,
    //   hit_feedback: false,
    //   head_intents: null,
    //   next_head_intents: null,
    //   categories: null,
    //   cat_intent_list: null,
    //   order: null,
    //   list_display_option: null,
    //   list_items: null,
    //   support_case_display: null,
    // },
    // HotQuestionCategory(),
    // IntentHotQuestion(),
    // NewHotQuestion(),
    // MSG(),
    // MSG('With br tag <br> <br><br><br> With br tag'),
    // ARTICLE(),
    // ARTICLE(3),
    // IFRAME_ARTICLE(),
    // OPTION(),
    // GENERAL_BTN('Please click the button below to change your phone number', [
    //   GENERAL_BTN_ITEM({
    //     button_type: 'btn_redirection',
    //     text_value: 'jump to google',
    //     url: 'https://google.com?s=a',
    //     style: 1,
    //     callback: tempCallback,
    //   }),
    //   GENERAL_BTN_ITEM({
    //     button_type: 'btn_redirection',
    //     text_value: 'order_detail_page',
    //     url: 'https://test.shopee.co.id/order/detail?shopid=123&orderid=123',
    //     uri_extra: {
    //       shop_id: 123,
    //       order_id: 123,
    //     },
    //     callback: tempCallback,
    //   }),
    // ]),
    // REDIRECTION(),
    // LIVE('call live agent', [{ queue_name: 'ID Chat-Buyer-General Enquiries' }]),
    // QA_BUTTON(),
    // MSG('ORDER'),
    // ORDER(),
    // MSG('RR_REQUEST_INFO'),
    // RR_REQUEST_INFO(),
    // TRANSACTION(),
    // TRANSACTION(2),
    // TRANSACTION(1, false),
    // GENERAL_BTN('Live', [
    //   GENERAL_BTN_ITEM({
    //     button_type: 'btn_live',
    //     text_key: 'sop_2_node_0_2_1_btn_1',
    //     queue_name: 'ID_Chat_Buyer_ShopeePay',
    //   }),
    //   GENERAL_BTN_ITEM({
    //     button_type: 'btn_taskbot',
    //     text_value: 'btn_taskbot with extra param',
    //     extra_param: {
    //       order_id: 123,
    //       a_id: 333,
    //     },
    //   }),
    // ]),
    // BUTTON_FOR_TASKBOT_HORIZONTAL(),
    // LIVE('call live agent', [{ queue_name: 'ID Chat-Buyer-ShopeePay' }]),
    // FEEDBACK([1, 2]),
    // FEEDBACK(['有用', '没用']),
    // FEEDBACK(['Yes', 'No']),
    // 直接触发重定向
    // DIRECTLY_REDIRECTION(),
    // Shopee Guarantee
    // GENERAL_BTN('Test Shopee Guarantee', [
    //   GENERAL_BTN_MODAL_GUARANTEE({ text_value: 'Open a Modal 1', yes_callback: { should_disappear: true }}),
    //   GENERAL_BTN_MODAL_GUARANTEE({ text_value: 'Open a Modal 2', yes_callback: { should_disappear: true }}),
    //   GENERAL_BTN_MODAL_GUARANTEE({ text_value: 'Open a Modal 3', yes_callback: { should_disappear: true }}),
    //   GENERAL_BTN_MODAL_GUARANTEE({ text_value: 'Open a Modal 4', yes_callback: { should_disappear: true }}),
    //   GENERAL_BTN_MODAL_GUARANTEE({ text_value: 'Open a Modal 5', yes_callback: { should_disappear: true }}),
    //   GENERAL_BTN_MODAL_GUARANTEE({ text_value: 'Open a Modal 6', yes_callback: { should_disappear: true }}),
    //   GENERAL_BTN_MODAL_GUARANTEE({ text_value: 'Open a Modal 7', yes_callback: { should_disappear: true }}),
    //   GENERAL_BTN_MODAL_GUARANTEE({ text_value: 'Open a Modal 8', yes_callback: { should_disappear: true }}),
    //   GENERAL_BTN_MODAL_GUARANTEE({ text_value: 'Open a Modal 9', yes_callback: { should_disappear: true }}),
    //   GENERAL_BTN_MODAL_GUARANTEE({ text_value: 'Open a Modal 10', yes_callback: { should_disappear: true }}),
    //   GENERAL_BTN_MODAL_GUARANTEE({
    //     text_value: 'Open a Modal 21',
    //     pop_up_content: {
    //       content:
    //         `You can extend Shopee Guarantee by 3 days to have more time to check your order after it's delivered. If you receive wrong, incomplete or damaged items, please request for a refund within 3 days of your order being delivered. `.repeat(
    //           3,
    //         ),
    //     },
    //   }),
    // ]),

    // LIVE('call id live agent', [{ queue_name: 'ID Chat-Buyer-General Enquiries' }]),
    // LIVE('call sg live agent', [{ queue_name: 'SG Chat-Buyer-Payments' }]),
    // LIVE('call inhouse live agent', [
    //   {
    //     user_type: 103,
    //     enquiry_type: 100208,
    //   },
    // ]),
    // LIVE('call inhouse live agent 2', [
    //   {
    //     user_type: 102,
    //     enquiry_type: 100205,
    //   },
    // ]),
    // OrderCard(),
    // GENERAL_BTN('You can check on the status of your other orders here', [
    //   GENERAL_BTN_ITEM({
    //     button_type: 'btn_redirection',
    //     text_value: 'jump to google',
    //     url: 'https://google.com?s=a',
    //     style: 1,
    //     callback: tempCallback,
    //   }),
    // ]),
    // SPLater(),
    // Announcement(),
    // MySupportCase(),
    // OrderCardWithHQ(),
    // PODIMAGE('https://www.ygexing.com/upload/223/new/20210303/15690311636958128.jpg'),
    // IMAGE('https://www.ygexing.com/upload/223/new/20210303/15690311636958128.jpg'),
    // IMAGE('https://www.ygexing.com/upload/223/new/2021033/15690311636958128.jpg'),
    // MSG(
    //   'For more information, please contact Ninjavan: \n\nWeb: https://www.google.com/a \nTel: 82711501 \nEmail: test@shopee.com',
    //   {},
    //   {
    //     buttons_for_feedback: [1, 2].map((feedback, index) => ({
    //       text_value: feedback,
    //       text_key: `btn_feedback_${index + 1}`,
    //     })),
    //     feedback_info: { style: 2 },
    //   },
    // ),
    // IntentSelector(),
    // OrdinatorySelector(),
    // OrderTipMsg(),
    // OrderSelectionFaq(),
    // OrderCardWithButton(),
    // CaseTrackerImprovement(),
    OrderCardWithHQ(),
    OrderCardWithHQOrderDetail(),
    PODIMAGE('https://www.ygexing.com/upload/223/new/20210303/15690311636958128.jpg'),
    IMAGE('https://www.ygexing.com/upload/223/new/20210303/15690311636958128.jpg'),
    IMAGE('https://www.ygexing.com/upload/223/new/2021033/15690311636958128.jpg'),
    MSG(
      'For more information, please contact Ninjavan: \n\nWeb: https://www.google.com/a \nTel: 82711501 \nEmail: test@shopee.com',
      {},
      {
        buttons_for_feedback: [1, 2].map((feedback, index) => ({
          text_value: feedback,
          text_key: `btn_feedback_${index + 1}`,
        })),
        feedback_info: { style: 2 },
      },
    ),
    IntentSelector(),
    OrdinatorySelector(),
    OrderTipMsg(),
    OrderSelectionFaq(),
    OrderCardWithButton(),
    FoodOrderCardWithButton(),
    OrderSelector,
    ChatUI_message(),
    CaseTrackerImprovement(),
  ],
};
